export enum UPDATED_PLAID_MESSAGING {
  USER_SETUP_REQUIRED = 'Your financial institution requires the primary account holder to either (1) be the user logging in and granting Plaid access (2) provide additional users the permissions to grant plaid access.',
}
